<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import { toVn } from '@/common/utils/Currency';
import { modalList, show } from '@/common/utils/ControlModal';

const { t } = useI18n();

const emit = defineEmits();
const props = defineProps(['data']);
const { data } = props;

const inputDeliveryFee = ref(0);
const capturedRoomNo = Number(store.state.chat?.selectedRoom?.roomNo);
const hasRoomAuthority = () => {
  const chat = store.state.chat;
  return (
    Number.isSafeInteger(capturedRoomNo) &&
    capturedRoomNo > 0 &&
    Number(chat?.desiredRoomNo) === capturedRoomNo &&
    Number(chat?.subscribedRoomNo) === capturedRoomNo &&
    Number(chat?.selectedRoom?.roomNo) === capturedRoomNo
  );
};

const fnSend = async () => {
  if (inputDeliveryFee.value == 0) {
    emit('close');
    return;
  }

  if (!hasRoomAuthority()) {
    emit('close');
    return;
  }

  const isUpdated = await store.dispatch('order/negoDeliveryFee', {
    orderNo: data.orderNo,
    deliveryFee: Number(inputDeliveryFee.value)
  });

  if (!isUpdated) {
    emit('close');
    show(modalList.Alert, {
      text: t('modal.nego-delivery-fee.fail'),
      confirmText: 'OK'
    });
    return;
  }

  if (!hasRoomAuthority()) {
    emit('close');
    return;
  }

  store.commit('chat/plusNegoDeliveryFee', {
    deliveryFee: Number(inputDeliveryFee.value)
  });

  const chatMsg = t('modal.nego-delivery-fee.chat-message', {
    deliveryFee: toVn(Number(inputDeliveryFee.value)),
    totalPrice: toVn(data.balance + data.deliveryFee + Number(inputDeliveryFee.value))
  });

  store.dispatch('chat/send', { roomNo: capturedRoomNo, msg: chatMsg });
  emit('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>{{ $t('modal.nego-delivery-fee.title') }}</h1>
          </div>

          <div class="modal-delete">
            <i class="i-modal-delete" @click="$emit('close')"></i>
          </div>

          <div class="modal-con check">
            <div class="modal-txt" style="align-items: center">
              <ul class="form-ul">
                <li class="form-li">
                  <div class="form-in">
                    <label class="label" style="padding-right: 10px">
                      <input type="number" v-model="inputDeliveryFee" />
                    </label>
                    đ
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-btn">
            <div class="btn-wrap">
              <!--                                <button class="btn bo">취소</button>-->

              <button class="btn yd-cta yd-cta--primary" @click="fnSend()">
                {{ $t('modal.nego-delivery-fee.apply') }}
              </button>

              <button class="btn bo yd-cta yd-cta--secondary" @click="$emit('close')">
                {{ $t('modal.nego-delivery-fee.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
